import React from 'react';
import { AuctionRow } from '../../../home/helpers/auctionRow';
import i18n from '../../../../i18n';
import { getLikedAuctions } from '../../../../models/auctions';
import { SideBar } from './../../components/Sidebar/Sidebar';
import { Spinner } from 'react-bootstrap';
import { getEnrolledGroups } from '../../../../models/groups';
import { HomeBanner } from '../../../home/homeBanner';
import HeaderBanner from '../../../common/HeaderBanner';
export class LikedAuctions extends React.Component {
    constructor() {
        super();
        this.state = {
            input: {},
            meta: {},
            groups: [],
            have_active_registrations: false,
            active_group: [],
            auctions: {},
            limit: 30,
            is_loading: false,
        };

        this.handleChange = this.handleChange.bind(this);
        this.loadAllAuctions = this.loadAllAuctions.bind(this);
    }

    async componentDidMount() {
        window.scrollTo(0, 0);
        this.loadAllGroups();
        this.loadAllAuctions(30);
    }

    async loadAllGroups() {
        const response = await getEnrolledGroups();
        let groups = response.data;
        this.setState({ groups });
        let meta = response.meta;
        if (meta && meta.active_group) {
            let { input } = this.state;
            input.group = meta.active_group.id;
            this.setState({
                input: input,
            });
        }
    }

    handleChange(event) {
        let input = this.state.input;
        input[event.target.name] = event.target.value;
    }

    async loadAllAuctions(limit = '') {
        this.setState({ is_loading: true });
        let { input } = this.state;
        let q = '';
        if (limit) {
            q = 'limit=' + limit;
        }
        if (input.group) {
            console.log(q);
            q = q ? q + `&group=${input.group}` : `?group=${input.group}`;
        }
        const response = await getLikedAuctions(q);
        if (response) {
            let auctions = response.data;
            this.setState({ auctions: auctions });
            this.setState({ is_loading: false });
        }
    }

    render() {
        let auctions = this.state.auctions;
        let limit = this.state.limit;
        let lt_30_cls =
            limit === 30 ? 'btn btn-primary btn-sm font-1vw' : 'btn btn-light btn-sm font-1vw';
        let lt_50_cls =
            limit === 50 ? 'btn btn-primary btn-sm font-1vw' : 'btn btn-light btn-sm font-1vw';
        let lt_100_cls =
            limit === 100 ? 'btn btn-primary btn-sm font-1vw' : 'btn btn-light btn-sm font-1vw';
        let lt_200_cls =
            limit === 200 ? 'btn btn-primary btn-sm font-1vw' : 'btn btn-light btn-sm font-1vw';
        let lt_all_cls =
            limit === false ? 'btn btn-primary btn-sm font-1vw' : 'btn btn-light btn-sm font-1vw';
        let total_auctions = this.state.meta.total;
        return (
            <React.Fragment>
                <HeaderBanner title={i18n.t('liked_auctions')} />


                <section className="sptb mt-5">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-3 col-lg-12 col-md-12">
                                <SideBar />
                            </div>
                            <div className="col-xl-9 col-lg-12 col-md-12 dash-container">
                                <div>

                                    {auctions.length === 0 && !this.state.is_loading && (
                                        <div className="card-body">
                                            <div className="alert alert-danger">{i18n.t('no_data_found')}</div>
                                        </div>
                                    )}

                                    <div className="card-body">


                                        {this.state.is_loading && (
                                            <div className="text-center m-3 text-dark" style={{ textAlign: 'center' }}>
                                                <Spinner animation="border" />
                                            </div>
                                        )}

                                        {auctions.length > 0 && !this.state.is_loading && (
                                            <div className="row">

                                                <div className="table-responsive group-list-section">
                                                    <div className="groups-table-container">

                                                        <div className="table-header">
                                                            <span
                                                                style={{ fontSize: '1rem', marginRight: '0.5rem' }}

                                                            >
                                                                {/* {this.hideSidebar && <i className="icon-size-actual"></i>}
                                                                {!this.props.hideSidebar && <i className="icon-size-fullscreen"></i>} */}
                                                            </span>

                                                            <h2>{i18n.t('liked_auctions')}</h2>
                                                            <span className="count-badge">{auctions.length} {i18n.t("auctions")}</span>
                                                        </div>


                                                        <div className="table-responsive">
                                                            {auctions.length > 0 && (
                                                                <table className="groups-table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>{i18n.t('#')}</th>
                                                                            <th>{i18n.t('auction_name')}</th>
                                                                            <th>{i18n.t('client')}</th>
                                                                            <th>{i18n.t('end_date')}</th>
                                                                            <th>{i18n.t('start_bid_amount')}</th>
                                                                            <th>{i18n.t('current_amount')}</th>
                                                                            <th>{i18n.t('bid_count')}</th>
                                                                            <th>
                                                                                {i18n.t('rank')}
                                                                            </th>
                                                                            <th></th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {auctions.map((item, i) => {
                                                                            let key = parseInt(i) + 1;
                                                                            return (
                                                                                <AuctionRow keys={key} auction={item} screen="dashboad" />
                                                                            );
                                                                        })}
                                                                    </tbody>
                                                                </table>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>


                                                <div>
                                                    <div className="p-1 item2-gl-nav">
                                                        <div className="d-sm-flex">

                                                            <div
                                                                style={{
                                                                    display: 'flex',
                                                                    justifyContent: 'space-between',
                                                                    alignItems: 'center',
                                                                    margin: '10px 0',
                                                                    width: '100%'
                                                                }}
                                                            >
                                                                <div>
                                                                    {!this.state.limit && (
                                                                        <div style={{ marginRight: '5px' }}>
                                                                            {i18n.t('showing')} {i18n.t('all')} {i18n.t('entries')}
                                                                        </div>
                                                                    )}

                                                                    {this.state.limit && (
                                                                        <div className="pagination-info group-list-section">
                                                                            <div className="rows-per-page">
                                                                                <label>
                                                                                    {i18n.t('showing')} 1 {i18n.t('to')} {this.state.limit}{' '}
                                                                                    {i18n.t('of')} {total_auctions} {i18n.t('entries')}
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </div>

                                                                <div>
                                                                    <label style={{ marginRight: '8px' }}>{i18n.t('show')}:</label>
                                                                    <select
                                                                        value={this.state.limit || 'all'}
                                                                        onChange={(e) => {
                                                                            const val = e.target.value === 'all' ? false : parseInt(e.target.value);
                                                                            this.setState({ limit: val });
                                                                            this.loadAllAuctions(val);
                                                                        }}
                                                                        style={{
                                                                            padding: '6px 12px',
                                                                            borderRadius: '6px',
                                                                            border: '1px solid #ccc',
                                                                            outline: 'none',
                                                                            cursor: 'pointer',
                                                                        }}
                                                                    >
                                                                        <option value="30">30</option>
                                                                        <option value="50">50</option>
                                                                        <option value="100">100</option>
                                                                        <option value="200">200</option>
                                                                        <option value="all">{i18n.t('all')}</option>
                                                                    </select>
                                                                </div>
                                                            </div>



                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </React.Fragment>
        );
    }
}
